import { GALLERY_URL_BY_CULTURE, GALLERY_URL_BY_ENV } from 'src/constants';

export default function generateUrl(culture: string, deployment: string): string {
    const url = (deployment.toLowerCase() === 'production')
        ? `https://gallery.vistaprint.${GALLERY_URL_BY_CULTURE[culture]}`
        : `https://gallery-6-client-${GALLERY_URL_BY_ENV[deployment]}.gallery.vpsvc.com`;

    return url;
}
